let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kk9To")).then(() => parcelRequire('iDNMw'));